import React, { useContext } from "react"
import styled, { FlattenSimpleInterpolation } from "styled-components"
import { IStyleVariant } from "../../design-system/atoms/variant-container"
import { SectionHeading, Wrapper } from "./faded-title.style"
import { UIContext } from "./layout"
import { T } from "./typography.styles"
export * from "./svg/title-fade"

interface IFadedTitleBase {
  title: string | JSX.Element
  alt?: string
  fadeSettings: IStyleVariant
  textAlign?: IStyleVariant
  sm?: FlattenSimpleInterpolation
  md?: FlattenSimpleInterpolation
  lg?: FlattenSimpleInterpolation
  className?: string
}

interface IFadedTitleImage extends IFadedTitleBase {
  image: string
  svg?: never
}
interface IFadedTitleSvg extends IFadedTitleBase {
  image?: never
  svg: JSX.Element
}

const FadedTitle = ({
  title,
  image,
  svg,
  alt = "",
  fadeSettings,
  textAlign,
  sm = T.sm.h2.bold,
  md = T.md.h2.bold,
  lg = T.lg.h2.bold,
  className,
  ...rest
}: IFadedTitleImage | IFadedTitleSvg) => {
  const {
    state: { breakpoint },
  } = useContext(UIContext)

  const alignment =
    typeof textAlign === "object" ? textAlign[breakpoint] : textAlign

  const textStyles = { sm, md, lg }

  return (
    <Wrapper
      imageType={svg ? `svg` : `img`}
      fadeSettings={fadeSettings}
      className={className}
      {...rest}
    >
      <SectionHeading textAlign={alignment} textStyles={textStyles}>
        {title}
      </SectionHeading>
      {svg ? svg : <img src={image} alt={alt} />}
    </Wrapper>
  )
}

export default styled(FadedTitle)``
